import axios from 'axios';
import { BASE_PATH_API } from 'constants/env';

export async function addReviews({
  customer_id,
  customer_name,
  customer_email,
  rating,
  title,
  review,
  rating_recommendation,
} = {}) {
  try {
    const { data } = await axios({
      url: `${BASE_PATH_API}/gift-table/v1/review`,
      method: 'POST',
      data: {
        customer_id,
        customer_name,
        customer_email,
        rating,
        title,
        review,
        rating_recommendation,
      }
    });
    return data.data;
  } catch (error) {
    console.log(error);
  }
}
